export const messages = {
  en: {
    userDetailAddress: {
      receiver: 'Receiver',
      receiverTel: 'Receiver Phone',
      receiverAddress: 'Receiver Address',
      isDefault: 'Default',
      yes: 'Yes',
      no: 'No',
      postalCode: 'Postal Code',
      createTime: 'Create Time'
    }
  },
  zh: {
    userDetailAddress: {
      receiver: '收货人',
      receiverTel: '收货电话',
      receiverAddress: '收货地址',
      isDefault: '默认',
      yes: '是',
      no: '否',
      postalCode: '邮编',
      createTime: '创建时间'
    }
  }
}